import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectVipcardRecoder(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/plus/vipcardRecode/select`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
// export function deleteUser(data) {
//   return request({
//     url: `/admin/plus/vipcardRecode/delete`,
//     method: "POST",
//     data,
//   });
// }
